import { Discount } from '@esportal/portal-service';
import { HuchaTier } from '../../shared/models/hucha-values';

export const RENOVADOR_PLUS15_NAME = 'renovadorPlus15';
export const RENOVADOR_10TO15_NAME = 'renovador10To15';

export const getHuchaTierFromDiscounts = (discounts: Discount[] = []): HuchaTier => {
	const discountNames = discounts.map((discount) => discount.name);

	if (discountNames.includes(RENOVADOR_PLUS15_NAME)) return RENOVADOR_PLUS15_NAME;
	if (discountNames.includes(RENOVADOR_10TO15_NAME)) return RENOVADOR_10TO15_NAME;

	return 'standard';
};
